<div class="space-between p-space-sm">
  @if (this.activeFilter()) {
    <div>
      <cam-filters-tag
        [activeFilter]="this.activeFilter()"
        (removedFilter)="this.removedFilter.emit($event)"
      ></cam-filters-tag>
    </div>
  }
  <div>
    <cam-link (action)="this.toggleFilter()">
      <cam-font-icon [name]="this.isFilterOpen ? 'check-line' : 'filter-tool'" type="lg"></cam-font-icon>
    </cam-link>
  </div>
</div>
<div>
  <cam-layout-with-panel [open]="this.isFilterOpen">
    <cam-layout-panel>
      <div class="p-space-sm">
        <cam-filters-form
          [form]="this.form()"
          [askValidation$]="this.askValidation$"
          (filtersSelected)="this.apply($event)"
        ></cam-filters-form>
      </div>
    </cam-layout-panel>
    <cam-layout-content>
      <ng-content></ng-content>
    </cam-layout-content>
  </cam-layout-with-panel>
</div>
